// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__LcntM","footer":"ChangeClinic_footer__SwDyg"};